import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { IGMCreateVideoTokenPayload } from './types/IGMCreateVideoTokenPayload';

export const getVideoToken = async (payload: IGMCreateVideoTokenPayload, userRole?: string): Promise<string> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const url = prefix ? `${prefix}/video/access_token` : '/videos/access_token';
  const { data } = await client.post(url, payload);

  return data.access_token;
};
